import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "./components/Home";
import Profiles from "./components/Profiles";
import GameChoice from "./components/GameChoice";
import Menu from "./components/Menu";
import Rules from "./components/Rules";
import Settings from "./components/Settings";
import GamePlay from "./components/GamePlay";
import VerifyPage from "./components/VerifyPage";
import ChangePassword from "./components/ChangePassword";
import ResetPassword from "./components/ResetPassword";

function App() {
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [selectedGame, setSelectedGame] = useState(null);
  const [token, setToken] = useState("");  

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home onNext={(token) => setToken(token)} />} />
        <Route path="/verify/:token" element={<VerifyPage />} />
        <Route
          path="/profiles"
          element={
            token ? (
              <Profiles
                token={token}
                onSelectProfile={(profile) => setSelectedProfile(profile)}
              />
            ) : (
              <Navigate to="/" />
            )
          }
        />

        <Route
          path="/gameChoice"
          element={
            token ? (
              <GameChoice
                token={token}
                onSelectGame={(game) => setSelectedGame(game)}
              />
            ) : (
              <Navigate to="/" />
            )
          }
        />

        <Route path="/menu" element={<Menu />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        <Route
          path="/game"
          element={<GamePlay/>}
          //</GamePlay>
            //</Router>selectedProfile && selectedGame ? (
              //<GamePlay profile={selectedProfile} game={selectedGame} />
            //) : (
             // <Navigate to="/profiles" />
           // )
          //}
        />

        <Route path="/verify" element={<VerifyPage />} />

        {/* fallback */}
        <Route path="*" element={<Navigate to="/" />} />

        <Route path="/change-password" element={<ChangePassword />} />
      </Routes>

    </Router>
  );
}

export default App;
